import React from 'react';
import { STYLES } from '../../constants/styles';
import { classNames, variantClass } from '../../utils/classNames';

interface BaseCardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'red' | 'transparent';
}

export const BaseCard: React.FC<BaseCardProps> = ({ 
  children, 
  className = '', 
  variant = 'default' 
}) => {
  const cardClasses = classNames(
    STYLES.CARDS.BASE,
    variantClass(variant, {
      default: STYLES.CARDS.DEFAULT,
      red: STYLES.CARDS.RED,
      transparent: STYLES.CARDS.TRANSPARENT,
    }),
    className
  );

  return (
    <div className={cardClasses}>
      {children}
    </div>
  );
};